/* eslint-disable react-refresh/only-export-components */
import { Tag, type TagProps } from 'antd';
import { BookingStatus } from '@dc-trans/data-layer';

export interface BookingStatusTagProps {
  status: BookingStatus;
  className?: string;
  bordered?: boolean;
}

type StatusConfig = {
  color: TagProps['color'];
  label: string;
};

export const statusColor: Record<BookingStatus, StatusConfig> = {
  [BookingStatus.All]: {
    color: 'default',
    label: 'Semua',
  },
  [BookingStatus.New]: {
    color: 'cyan',
    label: 'Baru',
  },
  [BookingStatus.InProgress]: {
    color: 'orange',
    label: 'Sedang Berlangsung',
  },
  [BookingStatus.Completed]: {
    color: 'green',
    label: 'Selesai',
  },
};

const BookingStatusTag = ({ status, className = 'text-sm!', bordered = false }: BookingStatusTagProps) => {
  const config = statusColor[status];

  if (!config) {
    console.warn(`Unknown booking status: ${status}`);
    return (
      <Tag color="default" bordered={bordered} className={`${className} mr-0! font-nunito!`}>
        {status}
      </Tag>
    );
  }

  return (
    <Tag color={config.color} bordered={bordered} className={`${className} mr-0! font-nunito!`}>
      {config.label}
    </Tag>
  );
};

export default BookingStatusTag;
